(function() { window.GUID_5427575e_8bf9_4406_b1cf_0bdc2dcd3627 = { getGuid: function() { return "5427575e-8bf9-4406-b1cf-0bdc2dcd3627"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        var VideoPlayerInternals;
        (function (VideoPlayerInternals) {
            class Fullscreen extends VideoPlayerInternals.BaseInternal {
                constructor(player) {
                    super(player);
                    this.fullscreenchange = (e) => { this.setFullscreenData(!!(document.fullscreen || document.fullscreenElement)); };
                    this.webkitfullscreenchange = (e) => { this.setFullscreenData(!!document.webkitIsFullScreen); };
                    this.mozfullscreenchange = (e) => { this.setFullscreenData(!!document.mozFullScreen); };
                    this.msfullscreenchange = (e) => { this.setFullscreenData(!!document.msFullscreenElement); };
                    this.ToggleFullscreen = () => {
                        if (this.IsFullScreen())
                            this.FullScreen(false);
                        else
                            this.FullScreen(true);
                    };
                    this.container = this.player.$Control;
                    this.fullScreenEnabled = !!(document.fullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled || document.webkitSupportsFullscreen || document.webkitFullscreenEnabled || document.createElement('video').webkitRequestFullScreen);
                }
                OnBindEvents() {
                    this.event(document)
                        .offon('fullscreenchange', this.fullscreenchange)
                        .offon('webkitfullscreenchange', this.webkitfullscreenchange)
                        .offon('mozfullscreenchange', this.mozfullscreenchange)
                        .offon('msfullscreenchange', this.msfullscreenchange);
                }
                setFullscreenData(state) {
                    this.container[0].setAttribute('data-fullscreen', String(!!state));
                    if (!!state)
                        this.container.addClass("is-fullscreen");
                    else
                        this.container.removeClass("is-fullscreen");
                    this.eventRaiser.FullscreenChange(null, { isFullScreen: !!state });
                }
                get FullScreenEnabled() { return this.fullScreenEnabled; }
                IsFullScreen() {
                    return !!(document.fullscreen || document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement || document.fullscreenElement);
                }
                FullScreen(enabled) {
                    if (enabled) {
                        if (this.container[0].requestFullscreen)
                            this.container[0].requestFullscreen();
                        else if (this.container[0].mozRequestFullScreen)
                            this.container[0].mozRequestFullScreen();
                        else if (this.container[0].webkitRequestFullScreen)
                            this.container[0].webkitRequestFullScreen();
                        else if (this.container[0].msRequestFullscreen)
                            this.container[0].msRequestFullscreen();
                        this.setFullscreenData(true);
                    }
                    else {
                        if (document.exitFullscreen)
                            document.exitFullscreen();
                        else if (document.mozCancelFullScreen)
                            document.mozCancelFullScreen();
                        else if (document.webkitCancelFullScreen)
                            document.webkitCancelFullScreen();
                        else if (document.msExitFullscreen)
                            document.msExitFullscreen();
                        this.setFullscreenData(false);
                    }
                }
                OnDispose() {
                }
            }
            VideoPlayerInternals.Fullscreen = Fullscreen;
        })(VideoPlayerInternals = Controls.VideoPlayerInternals || (Controls.VideoPlayerInternals = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=VideoPlayer.Fullscreen.pre.js.map
